import MAIPFooter from './MAIPFooter';

export default MAIPFooter;